import React from 'react';
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineDot from '@mui/lab/TimelineDot'
import './Timeline.css'

function CustomTimelineSeperator() {
    return (
        <TimelineSeparator className='separator-padding'>
        <TimelineDot variant='outlined' className='timeline-dot' />
        <TimelineConnector />
      </TimelineSeparator>
    )
}

export default CustomTimelineSeperator;